import { Component } from '@angular/core';
import { LenderService } from '../../../../../services/lender.service';
import { PCURLsService } from '../../../../../services/pcurls.service';
import { TrustedPartner } from '../../../../../shared/trusted-partner';
import { tap, switchMap } from 'rxjs/operators';

@Component({
    selector: 'app-trusted-partners',
    templateUrl: './trusted-partners.component.html',
    styleUrls: ['./trusted-partners.component.scss'],
    standalone: false
})
export class TrustedPartnersComponent {
  partnersData: TrustedPartner[] = [
    {
      partnerName: 'rocket',
      partnerUrl: null,
      partnerAlt: "Rocket Mortgage",
      imgSrc: "/application/views/www/public/assets/img/trusted-partners/rocket-mortgage.webp"
    },
    {
      partnerName: 'amerisave',
      partnerUrl: null,
      partnerAlt: "Amerisave Mortgage",
      imgSrc: "/application/views/www/public/assets/img/trusted-partners/amerisave.webp"
    },
    {
      partnerName: 'loan_depot',
      partnerUrl: null,
      partnerAlt: "Loan Depot",
      imgSrc: "/application/views/www/public/assets/img/trusted-partners/loan-depot.webp"
    },
    {
      partnerName: 'magnolia',
      partnerUrl: null,
      partnerAlt: "Magnolia Bank loans",
      imgSrc: "/application/views/www/public/assets/img/trusted-partners/magnolia-bank.webp"
    },
    {
      partnerName: 'federal',
      partnerUrl: null,
      partnerAlt: "The Federal Savings Bank buy or refinance a home",
      imgSrc: "/application/views/www/public/assets/img/trusted-partners/federal-savings.webp"
    },
    {
      partnerName: 'prosperity',
      partnerUrl: null,
      partnerAlt: "Prosperity Home Mortgage",
      imgSrc: "https://s3-us-west-2.amazonaws.com/fru-client-logos/production/300x100/34901.png?1708110544?1708110545305"
    }
  ];

  constructor(private lenderService: LenderService, private pcurlService: PCURLsService) {
    this.lenderService.getListings().pipe(
      tap(listings => {
        this.pcurlService.setListings(listings);
      }),
      switchMap(() => this.pcurlService.getPCURLs())
    ).subscribe(pc => {
      this.partnersData.forEach(partner => {
        if (pc.pc_urls.hasOwnProperty(partner.partnerName)) {
          partner.partnerUrl = pc.pc_urls[partner.partnerName];
        }
      });

      //add second row to array
      this.partnersData = this.partnersData.concat(this.partnersData.slice());
    });
  }
}
